import { render, staticRenderFns } from "./CifsView.vue?vue&type=template&id=e95e264a"
import script from "./CifsView.vue?vue&type=script&lang=js"
export * from "./CifsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports